var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSmileys(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 44 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Iconsax/Broken/smileys"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.66666 11.9266C3.66666 6.42656 5.86666 4.22656 11.3667 4.22656H17.9667C23.4667 4.22656 25.6667 6.42656 25.6667 11.9266V18.8932C20.5517 18.9849 18.425 21.1116 18.3333 26.2266H11.3667C5.86666 26.2266 3.66666 24.0266 3.66666 18.5266",
    stroke: "currentColor",
    strokeWidth: 2.915,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12.7599 11.3225C11.7882 10.6625 10.5049 10.6625 9.5332 11.3592M20.0932 11.3225C19.1215 10.6625 17.8382 10.6625 16.8665 11.3592M14.9599 21.4975H10.7065C10.1565 21.4975 9.71654 21.0575 9.71654 20.5075C9.71654 17.7759 11.9349 15.5575 14.6665 15.5575C15.8399 15.5575 16.9215 15.9609 17.7649 16.6392",
    stroke: "currentColor",
    strokeWidth: 2.915,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M40.3335 33.1936C40.3335 38.6936 38.1335 40.8936 32.6335 40.8936H26.0335C20.5335 40.8936 18.3335 38.6936 18.3335 33.1936V26.2269C18.4252 21.1119 20.5518 18.9852 25.6668 18.8936H32.6335C38.1335 18.8936 40.3335 21.0936 40.3335 26.5936",
    stroke: "currentColor",
    strokeWidth: 2.915,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M27.4269 25.5328C26.4552 26.1928 25.1719 26.1928 24.2002 25.4961M34.7602 25.5328C33.7885 26.1928 32.5052 26.1928 31.5335 25.4961M25.3735 30.2224H33.2935C33.8435 30.2224 34.2835 30.6624 34.2835 31.2124C34.2835 33.9441 32.0652 36.1624 29.3335 36.1624C26.6019 36.1624 24.3835 33.9441 24.3835 31.2124C24.3835 30.6624 24.8235 30.2224 25.3735 30.2224Z",
    stroke: "currentColor",
    strokeWidth: 2.915,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmileys);
export default __webpack_public_path__ + "static/media/smileys.33a2866e2f05504cc4aa6851c058092a.svg";
export { ForwardRef as ReactComponent };